import { UPDATE_PASSWORD } from './index';
import { Action } from '../action';
import { UpdatePasswordForm } from '@shared/core';

export class UpdatePasswordInitAction implements Action {
	readonly type = UPDATE_PASSWORD.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class UpdatePasswordDestroyAction implements Action {
	readonly type = UPDATE_PASSWORD.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class UpdatePasswordClickSubmitAction implements Action {
	readonly type = UPDATE_PASSWORD.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class UpdatePasswordClickLoginAction implements Action {
	readonly type = UPDATE_PASSWORD.CLICK_LOGIN;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class UpdatePasswordFormUpdateAction implements Action {
	readonly type = UPDATE_PASSWORD.FORM_UPDATE;
	constructor(
		public payload: UpdatePasswordForm,
		public correlationId?: number
	) {}
}

export class UpdatePasswordFormResetAction implements Action {
	readonly type = UPDATE_PASSWORD.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
